import { z } from "zod";

export const serverResponse = z.object({
  id: z.string(),
  type: z.literal("REGISTER"),
  status: z.literal("PENDING"),
  transactionLink: z.string(),
  transactionTimestamp: z.string(),
  transactionType: z.string(),
  orderId: z.string(),
  channel: z.object({
    id: z.literal("WEB"),
    name: z.literal("WEB"),
  }),
  payer: z.object({
    id: z.string(),
  }),
  paymentMethod: z.object({
    action: z.literal("REGISTER_EXCLUSIVE").or(z.literal("REGISTER")),
    methodType: z.literal("CREDIT_CARD"),
  }),
});
